import Auth from './../security/auth';
import { navigate } from '@reach/router';

export const defaultErrorHandler = (error) => {
    console.error(error);
    alert("Ein unbekannter Fehler ist aufgetreten.\n\nBitte kontaktieren Sie den Administrator,\nfalls das Problem weiterhin besteht.");
    Auth.logOut();
    navigate("/login");
};
